"use client";

import classNames from "classnames";
import React, { forwardRef } from "react";

import styles from "./tabs.module.scss";
import { TabsProps } from "./tabs.types";

const Tabs = forwardRef<HTMLDivElement, TabsProps>(({ current, stepsAmount, className }, ref) => {
  return (
    <div ref={ref} className={classNames(styles.tabs, className)}>
      {new Array(stepsAmount).fill(null).map((_, idx) => (
        <div key={idx} className={styles.root}>
          <div className={classNames(styles.indicator, idx <= current && styles.active)} />
        </div>
      ))}
    </div>
  );
});

Tabs.displayName = "Tabs";

export { Tabs };
